/*
 *  Shared helper for managing dismissible guide cards.
 *  Stores all dismiss states in a single localStorage key as a JSON object,
 *  e.g. { "step-select-studies": true, "step-select-software": true }
 *
 *  Usage:
 *    import { isGuideDismissed, dismissGuide, resetGuide } from './DismissedGuides';
 *    if (!isGuideDismissed('step-select-studies')) { ... }
 *    dismissGuide('step-select-studies');
 */

const STORAGE_KEY = 'swb-dismissed-guides';

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (_) {
    return {};
  }
}

function writeAll(obj) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch (_) {
    /* noop — private browsing etc. */
  }
}

export function isGuideDismissed(id) {
  return !!readAll()[id];
}

export function dismissGuide(id) {
  const all = readAll();
  all[id] = true;
  writeAll(all);
}

export function resetGuide(id) {
  const all = readAll();
  delete all[id];
  writeAll(all);
}

export function resetAllGuides() {
  writeAll({});
  // Also reset the dashboard welcome widget (uses its own key)
  try { localStorage.removeItem('swb-welcome-widget-dismissed'); } catch (_) { /* noop */ }
}
